module.exports = __webpack_public_path__ + "static/media/github.f4f7d011.svg";